import Rive from "@rive-app/react-canvas";

const ScreenLoader = () => {
  return (
    <div className="flex flex-row items-center justify-center align-center h-screen w-screen bg-[#151d2c]">
      <div className="h-[300px] w-[300px]">
        <Rive src="/loading.riv" stateMachines="State Machine 1" />
      </div>
    </div>
  );
};

export default ScreenLoader;
